import store from '..'
import firebase from 'firebase/app'

export default {
  namespaced: true,
  state () {
    return {
      chatMessage: {},
      reference: []
    }
  },
  getters: {
    chatMessage (state) {
      return state.chatMessage
    },
    reference (state) {
      return state.reference
    }
  },
  mutations: {
    init (state) {
      state.chatMessage = {}
      state.keys = []
    },
    boot (state, payload) {
      state.chatMessage[payload.key] = payload.data
    },
    add (state, payload) {
      var back = state.chatMessage
      if (back[payload.parentKey]) {
        var array = back[payload.parentKey]
        array.push(payload)
        back[payload.parentKey] = array
      } else {
        back[payload.parentKey] = [payload]
      }
      state.chatMessage = {}
      state.chatMessage = back
    },
    update (state, payload) {
      var back = state.chatMessage
      if (back[payload.parentKey]) {
        var array = back[payload.parentKey]
        var offset = array.findIndex(message => message.key === payload.key)
        if (offset !== -1) {
          array[offset] = payload
          back[payload.parentKey] = array
          state.chatMessage = {}
          state.chatMessage = back
        }
      }
    },
    remove (state, payload) {
      var back = state.chatMessage
      if (back[payload.parentKey]) {
        var array = back[payload.parentKey]
        var offset = array.findIndex(message => message.key === payload.key)
        if (offset !== -1) {
          array.splice(offset, 1)
          back[payload.parentKey] = array
          state.chatMessage = {}
          state.chatMessage = back
        }
      }
    },
    reference (state, payload) {
      state.reference.push(payload)
    }
  },
  actions: {
    init ({ commit }) {
      commit('init')
    },
    subscribe ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        var boot = true
        var temp = []
        var chatMessage = store.getters['chatMessage/chatMessage']
        var keys = Object.keys(chatMessage)
        var index = keys.indexOf(payload)
        if (index !== -1) {
          const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
          pause(100).then(() => { // dummy wait
            resolve()
          })
        }
        const db = firebase.firestore()
        var dbRef = db.collection('chats').doc(payload).collection('data')
        var reference = dbRef.where('visible', '==', true).orderBy('createdAt', 'desc').limit(100).onSnapshot(snapshots => {
          if (snapshots.empty) {
            resolve()
          }
          snapshots.docChanges().forEach(change => {
            var data = JSON.parse(JSON.stringify(change.doc.data()))
            data.key = change.doc.id
            data.parentKey = change.doc.ref.parent.parent.id
            if (boot && change.type === 'added') {
              temp.push(data)
            } else if (change.type === 'added') {
              commit('add', data)
            } else if (change.type === 'modified') {
              commit('update', data)
            } else if (change.type === 'removed') {
              commit('remove', data)
            }
          })
          if (boot) {
            boot = false
            commit('boot', { key: payload, data: temp })
          }
          resolve()
        })
        commit('reference', reference)
      })
    },
    unSubscribe ({ commit }) {
      return new Promise((resolve, reject) => {
        var reference = store.getters['chatMessage/reference']
        for (var ref in reference) {
          if (reference[ref]) {
            reference[ref]()
            commit('init')
          }
        }
        resolve()
      })
    }
  }
}
